const EmployeeService = require('@/services/users/EmployeeService')

import DepartmentService from '@/services/users/DepartmentService'

export default function (cb, preset) {

    DepartmentService.findAll({
        filter_groups: [
            {
                filters: [
                    {
                        key: 'title',
                        operator: 'in',
                        value: [
                            'Marketing',
                            'Andet',
                            'Web'
                        ]
                    }
                ]
            }
        ]
    }, response => {
        const data = response.data
        const rows = data.rows

        const options = {
            includes: ['department'],
            sort: [{
                key: 'name',
                direction: 'ASC'
            }],
            filter_groups: [
                {
                    filters: [
                        {
                            key: 'terminated',
                            value: 0,
                            operator: 'eq'
                        },
                        {
                            key: 'department.id',
                            operator: 'in',
                            value: rows.map(department => department.id)
                        }
                    ]
                }
            ]
        }

        EmployeeService.findAll(options, response => {
            const body = response.data

            let value = null

            const results = body.rows.map(employee => {
                return {
                    label: employee.name,
                    value: employee.id
                }
            })

            results.forEach(result => {
                if (result.value !== preset) {
                    return
                }

                value = preset
            })

            cb(results, value)
        })
    })
}
